import React from 'react';
import TrendingPanel from './trending-panel';

export default function TrendingPanelMobile(props) {
  return (<TrendingPanel {...props} classNames="trending-panel-mobile" />);
}
